<template>
  <div>
    <base-header class="pb-6 bg-default">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Files</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <base-button size="sm" type="neutral" v-on:click="$router.push('/media/file/new/' + containerId)">New</base-button>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6" v-if="files">
      <div class="row">
        <div class="col">
          <files-table :items="files"/>
        </div>
      </div>
    </div>
    <Loader v-else />
  </div>
</template>
<script>
  import {mapState} from "vuex";
  import {Dropdown, DropdownItem, DropdownMenu, Table, TableColumn} from 'element-ui';
  import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
  import FilesTable from "@/views/CORE/FilesTable";

  export default {
    name: 'files',
    components: {
      FilesTable,
      RouteBreadCrumb,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn
    },
    computed: {
      ...mapState({
        fileState: state => state.files,
      }),
      containerId: function() {
        return this.$route.params.id
      },
      files: function() {
        return this.fileState[this.containerId] || false
      }
    },
    methods: {
      loadFiles(id) {
        this.$store.dispatch('LOAD_API', {name: 'files', id: id, url: 'files/' + id})
      }
    },
    watch: {
      'containerId': function (id) {
        this.loadFiles(id)
      }
    },
    mounted() {
      this.loadFiles(this.containerId)
    }
  };
</script>
